'use client';

import { useEffect } from 'react';

/**
 * Client-side theme initializer to prevent hydration mismatches
 * This component runs only on the client side to initialize theme
 */
export function ThemeInitializer() {
  useEffect(() => {
    try {
      const theme = localStorage.getItem('theme');
      if (!theme) {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        document.documentElement.classList.toggle('dark', isDark);
      }
    } catch (error) {
      console.warn('Failed to initialize theme:', error);
    }
  }, []);

  return null;
}
